var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "section",
      { staticClass: "modal-card-body has-text-left" },
      [
        _c("step-tracker"),
        _vm._v(" "),
        _vm.loading
          ? _c("loader", { staticClass: "mt" })
          : _c(
              "div",
              [
                _c("h2", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: _vm.langRoot + ".reset.title",
                      expression: "`${langRoot}.reset.title`"
                    }
                  ],
                  staticClass: "step-heading"
                }),
                _vm._v(" "),
                _c("p", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: _vm.langRoot + ".reset.helper",
                      expression: "`${langRoot}.reset.helper`"
                    }
                  ]
                }),
                _vm._v(" "),
                _c("new-password", {
                  attrs: {
                    "default-focus": true,
                    "lang-root": _vm.langRoot + ".reset.setNewPassword"
                  },
                  model: {
                    value: _vm.newPassword,
                    callback: function($$v) {
                      _vm.newPassword = $$v
                    },
                    expression: "newPassword"
                  }
                })
              ],
              1
            )
      ],
      1
    ),
    _vm._v(" "),
    _c("footer", { staticClass: "modal-card-foot" }, [
      _c("div", { staticClass: "level is-block" }, [
        _c("div", { staticClass: "level-right is-pulled-right" }, [
          _c("button", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: _vm.langRoot + ".reset.submitBtn",
                expression: "`${langRoot}.reset.submitBtn`"
              }
            ],
            staticClass: "btn primary",
            class: { inactive: !_vm.isValid },
            attrs: {
              "data-ci": "pr-step3-next-button",
              disabled: !_vm.isValid
            },
            on: { click: _vm.submit }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "level-left is-pulled-left" }, [
          _c("button", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: _vm.langRoot + ".reset.cancelBtn",
                expression: "`${langRoot}.reset.cancelBtn`"
              }
            ],
            staticClass: "btn is-ghost",
            on: { click: _vm.cancel }
          })
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34d57ea1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34d57ea1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./login/Components/PasswordResetNew.vue
// module id = HMy6
// module chunks = 1